import { render, staticRenderFns } from "./VisitorRecordPage.vue?vue&type=template&id=d8fbdfde&scoped=true&"
import script from "./VisitorRecordPage.vue?vue&type=script&lang=js&"
export * from "./VisitorRecordPage.vue?vue&type=script&lang=js&"
import style0 from "./VisitorRecordPage.vue?vue&type=style&index=0&id=d8fbdfde&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fbdfde",
  null
  
)

export default component.exports